<div class="mobile-menu-search">
  <div class="mobile-menu-search__options">
    <app-menu-options></app-menu-options>
  </div>

  <div class="mobile-menu-search__input">
    <app-menu-search [component]="'menuabove'"></app-menu-search>
  </div>
</div>
